import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './styles/main.scss';
import Header from './components/Header/header';
import Home from './pages/Home/home';
import Retreats from './pages/Retreats/retreats';
import Contact from './components/Contact/contact';
import Footer from './components/Footer/footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={
              <>
                <Home />
                <Contact />
              </>
            } />
            <Route path="/retreats" element={<Retreats />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App; 